export default "__VITE_PUBLIC_ASSET__fd26db4a__"